var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.42,
    height: 21.42,
    viewBox: "0 0 21.42 21.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invoice",
    transform: "translate(-984.687 -588.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3500",
    "data-name": "Path 3500",
    d: "M995.4,606.784a7.256,7.256,0,1,1,7.256-7.257A7.251,7.251,0,0,1,995.4,606.784Zm0-15.867a8.611,8.611,0,1,0,8.611,8.61A8.605,8.605,0,0,0,995.4,590.917Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3501",
    "data-name": "Path 3501",
    d: "M995.385,594.221a5.295,5.295,0,1,0,5.3,5.295A5.295,5.295,0,0,0,995.385,594.221Zm0,11.143a5.848,5.848,0,1,1,5.848-5.848A5.851,5.851,0,0,1,995.385,605.364Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3502",
    "data-name": "Path 3502",
    d: "M995.4,589.258a10.269,10.269,0,1,1-7.262,17.531,10.262,10.262,0,0,1-2.226-3.332,10.272,10.272,0,0,1,.949-9.635,10.266,10.266,0,0,1,4.609-3.782,10.292,10.292,0,0,1,3.93-.782Z",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.882
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3503",
    "data-name": "Path 3503",
    d: "M997.779,598.009H996.7a2.129,2.129,0,0,0-.853-1.489h1.933a.213.213,0,1,0,0-.425h-4.5a.213.213,0,0,0,0,.425h1.289a1.718,1.718,0,0,1,1.7,1.489h-2.993a.213.213,0,0,0,0,.425h2.993a1.722,1.722,0,0,1-1.7,1.511H993.28a.216.216,0,0,0-.146.372l3.218,3.044a.212.212,0,0,0,.3-.009.216.216,0,0,0-.009-.3l-2.831-2.678h.753a2.15,2.15,0,0,0,2.134-1.936h1.08a.213.213,0,1,0,0-.425Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.ef8a3dd35a53306f559a4d3e2aa9d015.svg";
export { ForwardRef as ReactComponent };